import { graphql } from "../generated";

export const MeQuery = graphql(`
  query Me {
    me {
      treatments
      principal {
        key
      }
      user {
        key
        fullName
        firstName
        lastName
        email
        picture
      }
    }
  }
`);
